var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"flat":""}},[_vm._l((_vm.polls),function(poll){return _c('render-poll',{key:poll.id,attrs:{"id":poll.id}})}),(!_vm.polls.length)?_c('v-alert',{attrs:{"color":"lightest"}},[_vm._v(" No active polls ")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }